import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { DenunciasService } from '../denuncias.service';
import { EstadoPublicoDenuncia } from '../evidencia-permitida';

@Component({
  selector: 'app-confirmacion-denuncia',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './confirmacion-denuncia.component.html',
  styleUrls: ['./confirmacion-denuncia.component.css']
})
export class ConfirmacionDenunciaComponent implements OnInit {

  codigoSeguimiento: string = '';
  copiado: boolean = false;
  uploadWarning: string = '';

  // Consulta de estado
  codigoConsulta: string = '';
  // Solo lo que devuelve la consulta publica: codigo, estatus y fechas.
  denunciaConsultada: EstadoPublicoDenuncia = null;
  errorConsulta: string = '';
  buscando: boolean = false;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private denunciasService: DenunciasService,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    this.codigoSeguimiento = history.state?.codigoSeguimiento || '';
    this.uploadWarning = history.state?.uploadWarning || '';
    const codigoQuery = this.route.snapshot.queryParamMap.get('codigo') || '';
    if (codigoQuery) {
      this.codigoConsulta = codigoQuery.trim();
      this.consultarEstado();
    }
  }

  copiarCodigo(): void {
    if (this.codigoSeguimiento) {
      void navigator.clipboard.writeText(this.codigoSeguimiento).then(() => {
        this.copiado = true;
        this.syncView();
        setTimeout(() => {
          this.copiado = false;
          this.syncView();
        }, 2000);
      });
    }
  }

  consultarEstado(): void {
    const codigo = this.codigoConsulta.trim();

    if (!codigo) {
      this.errorConsulta = 'Ingresa un código de seguimiento.';
      return;
    }

    this.codigoConsulta = codigo;
    this.errorConsulta = '';
    this.buscando = true;
    this.denunciaConsultada = null;
    this.syncView();

    this.denunciasService.consultarEstadoDenuncia(codigo).subscribe({
      next: resp => {
        this.buscando = false;
        // La respuesta ya no trae id interno: el exito lo dice pCodRetorno.
        if (resp?.pCodRetorno === '0' && resp.codigoSeguimiento) {
          this.denunciaConsultada = resp;
          this.errorConsulta = '';
        } else {
          this.errorConsulta = resp?.pMensaje || 'No se encontró una denuncia con ese código.';
        }
        this.syncView();
      },
      error: () => {
        this.buscando = false;
        this.denunciaConsultada = null;
        this.errorConsulta = 'Error de conexión. Intente más tarde.';
        this.syncView();
      }
    });
  }

  onCodigoConsultaChange(): void {
    this.errorConsulta = '';

    if (this.denunciaConsultada &&
      this.codigoConsulta.trim() !== this.denunciaConsultada.codigoSeguimiento) {
      this.denunciaConsultada = null;
    }

    this.syncView();
  }

  getStatusValue(): number {
    return Number(this.denunciaConsultada?.id_estatus || 0);
  }

  isStatusReached(step: number): boolean {
    return this.getStatusValue() >= step;
  }

  isCurrentStatus(step: number): boolean {
    return this.getStatusValue() === step;
  }

  getProgressWidth(): string {
    switch (this.getStatusValue()) {
      case 1:
        return '0%';
      case 2:
        return '50%';
      case 3:
        return '100%';
      default:
        return '0%';
    }
  }

  getEstadoResumen(): string {
    switch (this.getStatusValue()) {
      case 1:
        return 'Su reporte fue recibido correctamente y está pendiente de revisión inicial.';
      case 2:
        return 'Su reporte está siendo revisado por el comité de ética. Recibirá una actualización pronto.';
      case 3:
        return 'La investigación del reporte concluyó y el caso fue marcado como cerrado.';
      default:
        return 'Su reporte está siendo procesado.';
    }
  }

  nuevaDenuncia(): void {
    this.router.navigate(['/denuncia/nuevo-reporte']);
  }

  cerrar(): void {
    const puedeIntentarCerrar = !!window.opener || window.history.length <= 1;

    if (puedeIntentarCerrar) {
      window.close();

      setTimeout(() => {
        if (!window.closed) {
          this.router.navigate(['/denuncia/inicio']);
        }
      }, 150);
      return;
    }

    this.router.navigate(['/denuncia/inicio']);
  }

  private syncView(): void {
    this.cdr.markForCheck();
    this.cdr.detectChanges();
  }
}
